<template>
  <div v-if="page" class="page" :class="{hiddenPrice: hiddenPrice}">
    <div v-if="isAvailable !== null"
      class="availableBox"
      :data-state="isAvailable ? '01' : '02'">
      <span class="message" @click="onTableOpen">
        <i></i> {{availableMessage}}
      </span>
      <em v-if="!pageState.available" @click="onTableOpen">{{locale.available_time}}</em>
    </div>
    <div id="article" class="article" ref="layerpopupPage" :class="{isExpressCheckin: isExpressCheckin}">
      <ExpressCheckin
        v-if="isExpressCheckin"
        :locale="locale" />
      <div v-for="mods in pageModule"
        :key="mods.id"
        :data-fullsize="mods.setting.layout.fullsize && mods.setting.layout.fullsize.active"
        :data-fullsize_align="mods.setting.layout.fullsize && mods.setting.layout.fullsize.active ? mods.setting.layout.fullsize.alignItems || 'center' : 'center'"
        :data-hidden="mods.hiddenModule || mods.hide"
        :style="{
          height: mods.setting.layout.fullsize && mods.setting.layout.fullsize.active ? `${fullsize}px` : 'auto',
          zIndex: popOver === mods.id ? zIndex || 99999 : ''
        }"
        v-show="!(mods.setting.action && mods.setting.action.isSubOption)"
        class="mods"
        :class="{notranslate: mods.setting.layout.noTranslate}">
        <Module
          :lang="lang"
          :pageId="id"
          :data="mods"
          :locale="locale"
          :subOption="subOption"
          :pageGuestType="pageGuestType"
          :isFolioInfo="isFolioInfo"
          :disabledSubmit="disabledSubmit"
          :usableCoupon="usableCoupon"
          :page="page"
          :pageState="pageState"
          :hasPrice="hasPrice"
          :priceInfo="priceInfo"
          :priceOption="priceOption"
          :getSubmitData="submitData"
          :hiddenPrice="hiddenPrice"
          :requiredCoupon="requiredCoupon"
          @updateUsableCoupon="updateUsableCoupon"
          @submitDataSetting="submitDataSetting"
          @setValue="setValue"
          @setPriceInfo="setPriceInfo"
          @setPriceOption="setPriceOption"
          @updateOption="updateOption"
          @setHasPrice="setHasPrice"
          @setPopover="setPopover"
          @summaryOn="summaryOn" />
      </div>
    </div>
    <Options
      :lang="lang"
      :locale="locale"
      :pageGuestType="pageGuestType"
      :getPriceInfo="priceInfo"
      :getPriceOption="priceOption"
      :getSubmitData="submitData" />
    <AvailableTable
      v-if="availableTable"
      :locale="locale"
      :table="page.available.set"
      :style="{zIndex: 9999999}"
      @close="onTableClose" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import API from '@/common/api'
import ExpressCheckin from './ExpressCheckin'
import Options from './Options'
import Module from './Module'
import moment from 'moment-timezone'
import { DateTime } from 'luxon'
import AvailableTable from '@/components/Util/AvailableTable'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'

export default {
  name: 'LayerpopupPage',
  props: [
    'id',
    'locale',
    'lang',
    'responsive',
    'translateType',
    'guestType',
    'roomKey'
  ],
  components: {
    ExpressCheckin,
    Module,
    AvailableTable,
    Options
  },
  computed: {
    ...mapGetters({
      setting: 'common/getSetting',
      getAvailableDay: 'util/getAvailableDay'
    }),
    isExpressCheckin () {
      return this.page && this.page.submit && this.page.submit.isSubmit && this.page.submit.submitTo === 'system_express_checkin'
    },
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    dateFormat () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      return date
    },
    dateTimeFormat () {
      const time = 'HH:mm'
      return `${this.dateFormat} ${time}`
    },
    pageGuestType () {
      const id = this.guestType ? this.guestType.id : null
      const defaultGuestType = this.setting.guestType || null
      const pageGuestType = id
        ? this.page.guestType // 페이지 개별설정
          ? this.page.guestType[0].setDefault
            ? defaultGuestType // 개별설정값이 있으나 공통값을 불러오도록 되어 있는지?
            : this.page.guestType
          : defaultGuestType
        : defaultGuestType // 공통설정
      return pageGuestType && this.guestType
        ? { ...pageGuestType.find(x => x.id === id), name: this.guestType.name }
        : null
    },
    isPublic () {
      return this.$store.getters['authentication/getAuthInfo'].public
    },
    pageModule () {
      const responsive = this.responsive
      const pageData = this.page
      let page = pageData.module
      if (pageData.mobileModule && pageData.tabletModule) {
        if (responsive === 'mobile') {
          page = pageData.mobileModule
        } else if (responsive === 'tablet') {
          page = pageData.tabletModule
        }
      }
      return page
    },
    isPreview () {
      return this.$store.state.authentication.preview && this.$store.state.authentication.preview === 'Y'
    },
    useBannerSite () {
      return this.$store.state.siteInfo.useBanner !== false
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    subOption () {
      const name = /radio|checkbox|select/
      const options = this.page.module.filter(x => x.type === 'action' && x.setting.action && name.test(x.setting.action.name)).map(x => {
        return {
          id: x.id,
          item: x.setting.action.item,
          label: x.setting.action.labelValue
        }
      }).filter(x => {
        return x.item.filter(o => o.subOption && o.subOption !== '').length > 0
      })
      function getSubOption (arr) {
        let result = []
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i]
          for (let j = 0; j < item.item.length; j++) {
            const opt = item.item[j]
            if (opt.subOption && opt.subOption !== '') {
              result.push({
                parent: item.id,
                parentLabel: item.label,
                parentValue: opt.value,
                child: opt.subOption
              })
            }
          }
        }
        return result
      }
      return getSubOption(options)
    },
    hiddenPrice () {
      return this.page.submit && this.page.submit.hiddenPrice
    },
    requiredCoupon () {
      return this.page.submit && this.page.submit.requiredCoupon
    }
  },
  watch: {
    '$route' (to, from, next) {
      if (to.params.id !== from.params.id) {
        this.pageInit()
        this.getPage()
      }
    },
    isExpressCheckin (isExpressCheckin) {
      const rid = this.$store.state.authentication.rid
      // (pms 연동 동을 통해 rid가 있는 경우) 중복체크인이 되지 않는다
      if (isExpressCheckin && rid) {
        this.$store.dispatch('authentication/checkExpressCheckein', rid).then((res) => {
          if (res && res.submit) {
            alert(this.locale.express_checkin_already_submit)
            this.$router.push({
              name: 'main'
            })
          }
        })
      }
    }
  },
  created () {
    window.addEventListener('resize', this.checkDeviceSize)
    this.getPage()
    this.pageInit()
  },
  beforeDestroy () {
    this.pageInit()
  },
  mounted () {
    this.checkDeviceSize()
    this.useCouponComplete()
  },
  destroyed () {
    window.removeEventListener('resize', this.checkDeviceSize)
  },
  data () {
    return {
      pageReady: false,
      isBanner: true,
      isAvailable: null,
      checkAvailable: 0,
      availableMessage: '',
      availableTable: false,
      device: {
        width: 0,
        height: 0
      },
      fullsize: 0,
      isSummary: false,
      isFolioInfo: false,
      disabledSubmit: false,
      popOver: '',
      zIndex: '',
      usableCoupon: [],
      page: null,
      pageState: null,
      hasPrice: null,
      priceOption: [],
      priceInfo: {},
      submitData: [],
      validate: '',
      submitCode: []
    }
  },
  methods: {
    // check ota valid
    async checkAuth () {
      const getAuthInfo = this.$store.state.authentication
      const key = getAuthInfo.k
      const space = getAuthInfo.space
      const hasKey = key && key !== 'undefined'
      const hasSpace = space && space !== 'undefined'
      const isKeyValid = !(getAuthInfo.otavalid && getAuthInfo.otavalid === 'false')
      const expressCheckin = this.getPage.submit && this.getPage.submit.submitTo === 'system_express_checkin'
      const isAuth = expressCheckin || (hasKey && hasSpace && isKeyValid)
      return isAuth
    },
    // 풀사이즈 모듈을 위한 디바이스 높이 구하여 적용
    checkDeviceSize () {
      const gnb = document.getElementById('gnb')
      this.device.width = window.innerWidth
      this.device.height = window.innerHeight
      this.fullsize = window.innerHeight
      // 모바일은 gnb가 상단에 있으므로 fullsize = height - gnb height
      if (window.innerWidth < 768 && gnb) {
        this.fullsize -= gnb.offsetHeight
      }
    },
    onTableOpen () {
      this.availableTable = true
    },
    onTableClose () {
      this.availableTable = false
    },
    varFormatter (data) {
      let value = ''
      if (data && data.value) {
        value = data.value
        switch (data.type) {
          case 'currency':
            const code = this.currencyCode
            value = regExp.priceFormat(value, code)
            break
          case 'integer':
            value = parseInt(value)
            break
          case 'float':
            value = parseFloat(value)
            break
          case 'datetime':
            const datetime = DateTime.fromISO(value || moment().toISOString(), { zone: this.timezone })
            value = datetime.toFormat(this.dateTimeFormat)
            break
          default: // string
            break
        }
      }
      return value
    },
    langObj (str) {
      const obj = {}
      const langs = this.$store.state.common.setting.lang.info
      for (let i = 0; i < langs.length; i++) {
        const langKey = langs[i].c
        obj[langKey] = str
      }
      return obj
    },
    priceFormat (price) {
      const code = this.currencyCode
      return price ? regExp.priceFormat(price, code) : ''
    },
    setHasPrice (data) {
      this.hasPrice = data
    },
    setPriceOption (data) {
      const prices = this.priceOption
      const isCheckbox = data.id.indexOf('_') !== -1
      if (!prices.find(x => x.id === data.id)) {
        if (data.price !== 0) {
          prices.push(data)
        }
      } else {
        if (data.price === 0 || isCheckbox) {
          prices.splice(prices.findIndex(x => x.id === data.id), 1)
        } else {
          prices.find(x => x.id === data.id).price = data.price
          prices.find(x => x.id === data.id).label = data.label
          prices.find(x => x.id === data.id).quantity = data.quantity
        }
      }
      if (data.subOptionList && prices.find(x => x.id === data.id)) {
        prices.find(x => x.id === data.id).subOptionList = data.subOptionList
        prices.find(x => x.id === data.id).subOptionValue = data.subOptionValue
      }
      const dataId = isCheckbox ? data.optId : data.id
      this.priceOption = prices.map(x => {
        const id = x.id.indexOf('_') !== -1 ? x.optId : x.id
        return {
          ...x,
          ...(x.isSub && (data.subOptionList && data.subOptionValue) && x.parentOption === dataId) && {
            hide: isCheckbox
              ? data.subOptionList.includes(id) && !data.subOptionValue.includes(id)
              : data.subOptionList.includes(id) && data.subOptionValue !== id
          }
        }
      })
    },
    setPriceInfo (data) {
      this.priceInfo = { ...this.priceInfo, ...data }
    },
    // folioAmount 객체를 통해 금액이 표시되는 체크박스 모듈 생성
    folioInfoModule (data, item, hasPrice) { // hasPrice || text
      /**
        * 전체 결제정보
        * 각 항목 checkbox의 옵션으로
        * 모두 체크하여 모듈로 추가
        * (결제정보에 tip이 있는 경우 옵션에 tip 추가)
        */
      const listObj = !item && {
        hasDefault: true,
        defaultValue: data.map((x, i) => {
          return `${i}_${x.name}(${this.priceFormat(x.unitPrice)}) * ${x.qty}`
        }),
        hasSubOption: false,
        isRequired: true,
        isSubOption: false,
        item: data.map(x => {
          return {
            value: `${x.name}(${this.priceFormat(x.unitPrice)}) * ${x.qty}`,
            price: '',
            label: this.langObj(`${x.name}(${this.priceFormat(x.unitPrice)}) * ${x.qty}`)
          }
        }),
        label: this.langObj('Items'),
        labelValue: getLabel('Items'),
        name: 'checkbox',
        disabledQty: true
      }
      /**
       * 결제정보 세부항목은
       * 금액포함하지 않고
       * 아이템별 각 checkbox 모듈로
       * value 하나씩 하여 노출
       */
      const itemObj = item && {
        hasDefault: true,
        defaultValue: data.name === 'payDetail'
          ? data.detail.map((x, i) => {
            return `${i}_${x.name}(${this.priceFormat(x.price)})`
          })
          : [`0_${getLabel(data.name)}(${this.priceFormat(data.unitPrice)})`],
        hasSubOption: false,
        isRequired: true,
        isSubOption: false,
        item: data.name === 'payDetail'
          ? data.detail.map(x => {
            return {
              value: `${x.name}(${this.priceFormat(x.price)})`,
              price: '',
              label: this.langObj(`${x.name}(${this.priceFormat(x.price)})`)
            }
          })
          : [{
            value: `${getLabel(data.name)}(${this.priceFormat(data.unitPrice)})`,
            price: (hasPrice && data.unitPrice) || '',
            label: this.langObj(this.priceFormat(data.unitPrice)),
            ...data.qty && {
              quantity: data.qty
            },
            ...hasPrice && {
              invisible: true
            }
          }],
        label: this.langObj(getLabel(data.name)),
        labelValue: getLabel(data.name),
        name: 'checkbox',
        disabledQty: true
      }
      const obj = {
        id: UNIQUE.mid(),
        moduleName: 'editor_module_checkbox',
        name: 'checkbox',
        type: 'action',
        dataSet: {
          mods: 'checkbox',
          column: [
            {
              columnId: UNIQUE.mid(),
              type: 'checkbox',
              value: {}
            }
          ]
        },
        setting: {
          action: item ? itemObj : listObj,
          detail: null,
          layout: {
            background: { active: false },
            border: { active: false },
            fullsize: { active: false },
            padding: { active: true, lr: 15, tb: 15 },
            text: { active: false }
          }
        },
        hiddenModule: true
      }
      function getLabel (name) {
        let label = ''
        if (name === 'payDetail') {
          label = 'Description'
        } else if (name === 'amount') {
          label = 'Total Amount Before VAT'
        } else if (name === 'tax') {
          label = 'Total VAT'
        } else if (name === 'totalAmount') {
          label = 'Total Amount'
        } else {
          label = name
        }
        return label
      }
      return obj
    },
    /**
     * 변수데이터(예약어) 처리
     * ota 기반이므로 valid 체크 후 조회
     */
    async getVariable () {
      const isAuth = await this.checkAuth()
      // 첫번째 노드에 변수데이터 변환
      function findVarChildNode (node, value) {
        if (node.hasChildNodes()) {
          if (node.childNodes[0].nodeType === 3 && value !== '') {
            node.innerText = value
          } else {
            findVarChildNode(node.childNodes[0], value)
            for (let i = 1; i <= node.childNodes.length; i++) {
              if (node.childNodes[i] && value !== '') {
                node.childNodes[i].innerText = ''
              }
            }
          }
        }
      }
      if (isAuth && this.$refs.layerpopupPage && this.$refs.layerpopupPage.querySelectorAll('[data-variable]').length) {
        const varEl = this.$refs.layerpopupPage.querySelectorAll('[data-variable]')
        let vars = []
        for (let i = 0; i < varEl.length; i++) {
          // 변환할 변수명
          vars.push(varEl[i].dataset.variable)
        }
        this.$store.commit('loading', true)
        this.$store.dispatch('authentication/getVariable', vars).then((varRes) => {
          // 변수명으로 요청한 데이터 리턴
          if (varRes) {
            const varValue = Object.keys(varRes).map(x => {
              return {
                key: x,
                value: varRes[x].value.value,
                type: varRes[x].value.type
              }
            })
            if (varValue.length > 0) {
              // 엘리먼트에 맵핑
              for (let i = 0; i < varEl.length; i++) {
                const varKey = varEl[i].dataset.variable
                // 일반적인 예약어(이름, 투숙기간 등) - 텍스트 대체
                if (varKey !== 'folioInfo') {
                  varEl[i].classList.add('notranslate')
                  findVarChildNode(varEl[i], this.varFormatter(varValue.find(v => v.key === varKey)))
                } else {
                  /**
                   * 미결제 금액 정보 (보통 체크아웃 시)
                   * 미결제 금액과 함께
                   * 금액 상세 내역 표시
                   * 보이지 않는 옵션(checkout) 생성하여
                   * 결제금액 연결 후 실결제까지
                   */
                  const folioInfo = varValue.find(v => v.key === varKey).value
                  varEl[i].classList.add('notranslate')
                  this.isFolioInfo = true
                  // 발생한 금액 상세 리스트, 합계에 포함하지 않고 단순 텍스트 노출용
                  if (folioInfo.folioList) {
                    const index = this.pageModule.length
                    this.$store.commit('page/addModule', {
                      index: index,
                      item: this.folioInfoModule(folioInfo.folioList, false, false)
                    })
                  }
                  // 발생한 금액의 상세정보
                  if (folioInfo.payList) {
                    // 금액에 부가세가 있다면 결제시 istay 자체 부가세 계산 하지 않음
                    if (folioInfo.payList.tax) {
                      this.$store.commit('page/disabledTax', true)
                    }
                    // 총액 표기
                    if (folioInfo.payList.totalAmount) {
                      findVarChildNode(varEl[i], this.varFormatter({ type: 'currency', value: folioInfo.payList.totalAmount }))
                    }
                    // 결제내역 옵션으로 생성(모두 체크된 상태로)
                    Object.keys(folioInfo.payList).forEach((key) => {
                      const info = {
                        name: key,
                        ...key === 'payDetail' && {
                          detail: Object.keys(folioInfo.payList[key]).map(x => {
                            return { name: x, price: folioInfo.payList[key][x] }
                          })
                        },
                        ...key !== 'payDetail' && {
                          unitPrice: folioInfo.payList[key]
                        }
                      }
                      const index = key === 'payDetail' ? 0 : this.pageModule.length
                      if (key !== 'paymentAble') {
                        this.$store.commit('page/addModule', {
                          index: index,
                          item: this.folioInfoModule(info, true, key === 'totalAmount')
                        })
                      } else if (folioInfo.payList.paymentAble === false) {
                        /**
                         * folioInfo - paymentAble: false이면 결제불가, 전송자체도 불가
                         * 추후 전송 페이지이지만 특정 조건에 의해 전송을 막아야 할 때
                         * disabledSubmit = ${reason}
                         */
                        this.disabledSubmit = 'paymentAble'
                      }
                    })
                  }
                  /**
                   * folioInfo - checkOutAble: false이면
                   * 시스템적인 에러로 인한 데이터 조회 실패로
                   * 결제(정보가 제대로 안나올 수 있음)불가,
                   * 전송(결제가 있을 수 있으므로)불가
                   */
                  if (folioInfo.checkOutAble === false) {
                    this.disabledSubmit = 'checkOutAble'
                    alert(`${this.locale.message_disabled_checkoutable_1}\n${this.locale.alert_checkout_front}`)
                  }
                }
              }
            }
          } else {
            alert(`${this.locale.alert_data_load_fail}\ndata: ${varRes}`)
          }
          this.$store.commit('loading', false)
        })
      }
    },
    updateOption (data) {
      const option = this.priceOption.find(x => x.id === data.id)
      if (option) {
        option.quantity = data.quantity
      }
    },
    submitDataSetting (data) {
      this.submitData = this.submitData.find(x => x.id === data.id)
        ? this.submitData.map(x => x.id === data.id ? data : x)
        : this.submitData.concat(data)
    },
    setValue (data) {
      const submitModule = this.submitData.find(x => x.id === data.id)
      function getIndex (string) {
        const index = string.substring(0, string.indexOf('_'))
        return Number(index)
      }
      if (submitModule) {
        submitModule.value = data.value
        if (Array.isArray(data.value) && data.type !== 'upload') {
          const valueIndex = data.value.map(x => getIndex(x))
          submitModule.valueIndex = valueIndex
          submitModule.valueOption = []
          valueIndex.forEach(function (x) {
            submitModule.valueOption.push(data.valueOption[x])
          })
          submitModule.condition = data.condition
        } else {
          if (data.valueOption) {
            submitModule.valueOption = data.valueOption.find((x, index) => index === getIndex(data.value))
          }
        }
        if (data.isInput) {
          submitModule.isInput = data.isInput
        } else {
          delete submitModule.isInput
        }
        submitModule.passed = data.passed
      }
    },
    setPopover (id, zIndex) {
      this.popOver = id
      this.zIndex = zIndex
    },
    setPage (data) {
      const lang = this.$store.state.common.lang.default
      const isVisible = data.data.state === '01' // 페이지 자체 공개여부
      let available = data.data.available // submit 데이터
      const isAlways = available.state === '01' // 01 ? always : each
      const today = moment().isoWeekday() - 1
      const day = available.set[today]
      const getAvailableDay = this.$store.getters['util/getAvailableDay']
      const check = getAvailableDay(day)
      const isAvailable = isAlways
        ? true
        : check
      function getSubOption (arr) {
        let result = []
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i]
          if (item.item) {
            for (let j = 0; j < item.item.length; j++) {
              const opt = item.item[j]
              if (opt.subOption && opt.subOption !== '') {
                result.push({
                  parent: item.id,
                  parentLabel: item.label,
                  parentValue: opt.value,
                  child: opt.subOption
                })
              }
            }
          }
        }
        return result
      }
      function setActionModules (data) {
        data.module.filter(x => x.type === 'action' && x.setting.action && x.setting.action.name === 'input').map(x => {
          return {
            id: x.id,
            item: x.setting.action.item,
            label: x.setting.action.labelValue
          }
        })
        if (data.module) {
          const name = /input|radio|checkbox|select/
          const subModules = data.module.filter(x => x.type === 'action' && x.setting.action && name.test(x.setting.action.name)).map(x => {
            return {
              id: x.id,
              item: x.setting.action.item,
              label: x.setting.action.labelValue
            }
          }).filter(x => x.item ? x.item.filter(o => o.subOption && o.subOption !== '').length > 0 : x)
          const subOption = getSubOption(subModules)
          data.subOption = subOption
          data.module.forEach(function (module) {
            if (module.type === 'action' && module.setting.action) {
              if (name.test(module.setting.action.name)) {
                /**
                 * 서브옵션이 input인 경우
                 */
                if (module.setting.action.name === 'input') {
                  module.setting.action.isSubOption = subOption.filter(x => x.child === module.id).length > 0
                } else {
                  /**
                   * 에디터에서 value를 별도로 입력하지 않은 경우
                   * 대표언어의 label을 value로 처리
                   */
                  module.setting.action.item.forEach(function (option) {
                    option.value = regExp.replaceAllEmpty(option.value).length > 0 ? option.value : option.label[lang]
                  })
                  /**
                   * 옵션 선택값에 따라
                   * 서브옵션 유무 추가
                   */
                  module.setting.action.hasSubOption = subOption.filter(x => x.parent === module.id).length > 0
                  module.setting.action.isSubOption = subOption.filter(x => x.child === module.id).length > 0
                  if (subOption.find(x => x.child === module.id)) {
                    module.setting.action.parentOption = subOption.find(x => x.child === module.id).parent
                  }
                }
              }
            }
          })
          // 레이어팝업은 페이지를 복사했을 때 모듈/컬럼 id가 중복될 수 있으므로 새로 uuid 생성해야 한다
          // 기존 복사된 id를 데이터로 사용하는 부분이 있어(하위옵션) id-label for-name만 변경
          /*
          data.module = data.module.map(x => {
            return {
              ...x,
              id: UNIQUE.mid(),
              dataSet: {
                ...x.dataSet,
                column: x.dataSet.column.map(c => {
                  return {
                    ...c,
                    columnId: UNIQUE.mid()
                  }
                })
              }
            }
          })
          */
        }
        if (data.mobileModule) {
          const name = /input|radio|checkbox|select/
          const subModules = data.mobileModule.filter(x => x.type === 'action' && x.setting.action && name.test(x.setting.action.name)).map(x => {
            return {
              id: x.id,
              item: x.setting.action.item,
              label: x.setting.action.labelValue
            }
          }).filter(x => x.item ? x.item.filter(o => o.subOption && o.subOption !== '').length > 0 : x)
          const subOption = getSubOption(subModules)
          data.mobileModule = data.mobileModule.map(x => {
            return {
              ...x,
              id: UNIQUE.mid(),
              dataSet: {
                ...x.dataSet,
                column: x.dataSet.column.map(c => {
                  return {
                    ...c,
                    columnId: UNIQUE.mid()
                  }
                })
              }
            }
          })
          data.subOption = subOption
          data.mobileModule.forEach(function (module) {
            if (module.type === 'action' && module.setting.action) {
              if (name.test(module.setting.action.name)) {
                /**
                 * 서브옵션이 input인 경우
                 */
                if (module.setting.action.name === 'input') {
                  module.setting.action.isSubOption = subOption.filter(x => x.child === module.id).length > 0
                } else {
                  /**
                   * 에디터에서 value를 별도로 입력하지 않은 경우
                   * 대표언어의 label을 value로 처리
                   */
                  module.setting.action.item.forEach(function (option) {
                    option.value = regExp.replaceAllEmpty(option.value).length > 0 ? option.value : option.label[lang]
                  })
                  /**
                   * 옵션 선택값에 따라
                   * 서브옵션 유무 추가
                   */
                  module.setting.action.hasSubOption = subOption.filter(x => x.parent === module.id).length > 0
                  module.setting.action.isSubOption = subOption.filter(x => x.child === module.id).length > 0
                  if (subOption.find(x => x.child === module.id)) {
                    module.setting.action.parentOption = subOption.find(x => x.child === module.id).parent
                  }
                }
              }
            }
          })
        }
        if (data.tabletModule) {
          const name = /input|radio|checkbox|select/
          const subModules = data.tabletModule.filter(x => x.type === 'action' && x.setting.action && name.test(x.setting.action.name)).map(x => {
            return {
              id: x.id,
              item: x.setting.action.item,
              label: x.setting.action.labelValue
            }
          }).filter(x => x.item ? x.item.filter(o => o.subOption && o.subOption !== '').length > 0 : x)
          const subOption = getSubOption(subModules)
          data.tabletModule = data.tabletModule.map(x => {
            return {
              ...x,
              id: UNIQUE.mid(),
              dataSet: {
                ...x.dataSet,
                column: x.dataSet.column.map(c => {
                  return {
                    ...c,
                    columnId: UNIQUE.mid()
                  }
                })
              }
            }
          })
          data.subOption = subOption
          data.tabletModule.forEach(function (module) {
            if (module.type === 'action' && module.setting.action) {
              if (name.test(module.setting.action.name)) {
                /**
                 * 서브옵션이 input인 경우
                 */
                if (module.setting.action.name === 'input') {
                  module.setting.action.isSubOption = subOption.filter(x => x.child === module.id).length > 0
                } else {
                  /**
                   * 에디터에서 value를 별도로 입력하지 않은 경우
                   * 대표언어의 label을 value로 처리
                   */
                  module.setting.action.item.forEach(function (option) {
                    option.value = regExp.replaceAllEmpty(option.value).length > 0 ? option.value : option.label[lang]
                  })
                  /**
                   * 옵션 선택값에 따라
                   * 서브옵션 유무 추가
                   */
                  module.setting.action.hasSubOption = subOption.filter(x => x.parent === module.id).length > 0
                  module.setting.action.isSubOption = subOption.filter(x => x.child === module.id).length > 0
                  if (subOption.find(x => x.child === module.id)) {
                    module.setting.action.parentOption = subOption.find(x => x.child === module.id).parent
                  }
                }
              }
            }
          })
        }
        return data
      }
      this.page = setActionModules(data.data)
      this.page.id = data.id
      this.page.available = {
        ...this.page.available,
        set: this.page.available.set.map(x => {
          const time = x.time || (x.timeFrom && x.timeTo && {
            time: [
              {
                from: x.timeFrom,
                to: x.timeTo
              }
            ]
          })
          return {
            ...x,
            ...time
          }
        })
      }
      this.pageState = {
        visible: isVisible,
        available: isAvailable
      }
    },
    async loadPage (id) {
      const siteId = id.split('.')[0]
      // const siteId = API.SITE_INFO.site
      const file = `page/item/${id}.json`
      try {
        const res = await this.$axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${siteId}&file=${file}`)
        this.setPage({ id: id, data: res.data.message })
        return res.data.message
      } catch (ex) {
        return ex
      }
    },
    async getPage () {
      this.$store.commit('loading', true)
      const pageId = typeof (this.id) === 'undefined' ? this.$store.state.common.setting.main.page : this.id
      await this.loadPage(pageId).then((res) => {
        if (res.id) {
          const subTags = document.querySelectorAll('.article sub')
          const subStyles = document.querySelectorAll('[style*="vertical-align: sub"]')
          subTags.forEach(function (sub) {
            sub.classList.add('notranslate')
          })
          subStyles.forEach(function (sub) {
            sub.classList.add('notranslate')
          })
          this.$store.commit('loading', false)
          // 페이지 변수 정보 변환 (guestName, folioInfo, ...)
          this.getVariable()
          if ((this.pageState !== null && !this.pageState.visible) || (this.pageGuestType && this.pageGuestType.active && this.pageGuestType.hide)) {
            alert(this.locale.private_page)
            if (this.$route.name.includes('product')) {
              // this.$emit('destroy')
            } else {
              this.$router.go(-1)
            }
          }
          if (res.submit.isSubmit && res.available.state !== '01') {
            this.checkAvailableTime()
          }
        } else {
          // 페이지가 없으면 레이어팝업 아이템 삭제
          this.$store.commit('loading', false)
        }
      })
    },
    pageInit () {
      // page init (page)
      this.page = null
      this.pageState = null
      this.hasPrice = false
      // price init (page)
      this.priceOption = []
      this.priceInfo = {}
      // submit init (submit)
      this.submitData = []
      this.validate = ''
      this.submitCode = []
      // 이 페이지에서 사용 가능한 쿠폰(filter get-my-coupon)
      if (this.roomKey) {
        this.$store.dispatch('coupon/getCoupon').then((res) => {
          if (res && res.length > 0) {
            const usableCoupon = res.filter(x => {
              const usePage = x.payload.usePage && x.payload.usePageIds && x.payload.usePageIds.length > 0
              const pageIds = usePage && x.payload.usePageIds.map(p => p.pageId)
              return usePage && pageIds.includes(this.id)
            })
            this.usableCoupon = usableCoupon
            this.$store.commit('page/usableCoupon', usableCoupon)
          } else {
            this.usableCoupon = []
          }
        })
      }
      clearInterval(this.checkAvailable)
      this.isAvailable = null
      this.isFolioInfo = false
    },
    useCouponComplete () {
      /**
       * 이 페이지가 완료페이지인 경우 쿠폰 사용처리
       * (결제 때문에 complete 에서도 체크하기 위해 로컬스토리지에 저장)
       */
      this.$store.dispatch('coupon/getWaitCoupon').then((iids) => {
        if (iids) {
          this.$store.dispatch('coupon/useCoupons', iids)
        }
      })
    },
    checkAvailableTime () {
      const page = this.page
      function timeMessage (arr) {
        arr = arr.map(x => {
          return `${x.from} ~ ${x.to}`
        })
        return arr.join(' / ')
      }
      this.checkAvailable = setInterval(() => {
        const available = page.available // submit 데이터
        const isAlways = available.state === '01' // 01 ? always : each
        const today = moment().isoWeekday() - 1
        const day = available.set[today]
        const check = this.getAvailableDay(day)
        const isAvailable = isAlways
          ? null
          : check
        this.isAvailable = page.submit.isSubmit ? isAvailable : null
        this.availableMessage = !check ? this.locale.not_available : timeMessage(day.time)
        this.pageState.available = this.isAvailable
      }, 1000)
    },
    summaryOn (summaryOn) {
      this.isSummary = summaryOn
    },
    updateUsableCoupon (couponList) {
      this.usableCoupon = couponList
    }
  }
}
</script>

<style lang="scss" scoped>
[data-pagetype="dgb"] {
  position: relative;
  &:after {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 30px;
    height: 100%;
    background-image: linear-gradient(to right, rgba(0,0,0,0.1), transparent);
  }
}
.availableBox {
  padding: 0.5em 15px;
  border-bottom: 1px solid $color-lgrey2;
  &[data-state="01"] i {
    background-color: $color-green;
  }
  &[data-state="02"] i {
    background-color: $color-red;
  }
  i {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background-color: $color-green;
  }
  .message {
    display: inline-block;
    padding: 0.3em 1em;
    font-size: 0.85em;
    color: $color-white;
    vertical-align: middle;
    border-radius: 3em;
    background-color: $color-dark;
  }
  em {
    display: inline-block;
    position: relative;
    margin-left: 6px;
    padding: 2px 4px;
    text-align: center;
    vertical-align: middle;
    font-size: 12px;
    font-weight: bold;
    font-family: 'arial';
    color: $color-white;
    border-radius: 4px;
    background-color: $color-red;
    cursor: pointer;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      width: 6px;
      height: 6px;
      margin-top: -3px;
      margin-left: -3px;
      border-radius: 2px;
      background-color: $color-red;
      transform: rotate(45deg);
    }
  }
}
</style>
